<template>
	<div class="hero-info-box">
		<div class="content-type">
			<img class="logo" src="../../images/logo.png" alt="logo" />
			<h2 class="vl-font-size--40 item-type">{{ contentType }}</h2>

			<button
				v-tooltip.top="muted ? 'Ενεργοποίηση ήχου' : 'Σίγαση ήχου'"
				class="btn--circle volume"
				v-focus
				:class="{ muted: muted === true }"
				@click="toggleMute(muted)"
			>
				<IconVolume />
			</button>
		</div>
		<h1 class="hero-title" @click="navigateToInnerPage(item?.drupal_internal__nid)">
			<span
				class="hero-title vl-font-weight--black"
				:class="[{ medium: !item?.field_large_title_part, large: item?.field_large_title_part }]"
			>
				{{ item?.field_small_title_part ?? item?.title }}</span
			>
			<span class="hero-title medium vl-font-weight--black" v-if="item?.field_large_title_part">
				{{ item.field_large_title_part }}
			</span>
		</h1>

		<div id="custom-pagination"></div>
	</div>
</template>

<script lang="ts" setup>
	import { computed, ref } from "vue"
	import { Movie } from "../../types/Movie"
	import { Series } from "../../types/Series"
	import { useI18n } from "vue-i18n"
	import IconVolume from "../../icons/IconVolume.vue"
	import { useTeaserStore } from "../../stores/teaser"
	import { useRouter } from "vue-router"
	const router = useRouter()
	const teaserStore = useTeaserStore()
	const { t } = useI18n()
	const muted = computed(() => teaserStore.heroSectionState.isMuted)
	const props = defineProps<{
		item: Movie | Series | null
	}>()

	const contentType = computed(() =>
		props.item?.type.replace("node--", "") === "movie" ? t("generic.movie") : t("generic.series")
	)

	const toggleMute = (muted: boolean) => {
		// Emit event to parent to toggle mute state
		teaserStore.heroSectionState.isMuted = !muted
	}

	/**
	 * Navigate to inner page based on content type.
	 * @param id
	 */
	const navigateToInnerPage = async (id) => {
		router.push({
			name: props.item?.type?.includes("movie") ? "InnerMovie" : "InnerSeries",
			params: {
				id: id,
			},
		})
	}
</script>

<style lang="scss">
	.content-type {
		display: flex;
		align-items: flex-end;
		margin-bottom: 30px;
		max-width: 250px;
		cursor: default;

		h2 {
			text-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
		}

		@include br.respond-to(br.$tablet-medium) {
			// display: none;
			margin-bottom: 10px;
			h2 {
				font-size: 24px;
			}
		}

		.logo {
			max-width: 68px;
			height: auto;

			@include br.respond-to(br.$desktop-medium) {
				max-width: 40px;
			}
		}
		h2 {
			text-transform: capitalize;
		}
	}
	.hero-title {
		// max-width: 50%;
		line-height: 1;
		cursor: pointer;
		text-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
		@extend .vl-font-size--75;

		@include br.respond-to(br.$tablet-medium) {
			font-size: 38px;
			max-width: 100%;
		}

		&.large {
			display: block;
			line-height: 1;
			text-shadow: 0 0 10px rgba(0, 0, 0, 0.7);

			@include br.respond-to(br.$desktop-medium) {
				font-size: 50px;
			}
			@include br.respond-to(br.$tablet-medium) {
				font-size: 38px;
			}
		}
		&.medium {
			display: block;
			line-height: 1;
			text-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
			// min-height: 40px;
			@extend .vl-font-size--105;

			@include br.respond-to(br.$desktop-medium) {
				font-size: 80px;
			}

			@include br.respond-to(br.$tablet-medium) {
				font-size: 50px;
			}
			@include br.respond-to(br.$mobile-xlarge) {
				font-size: 38px;
			}
		}

		span {
			display: block;
			line-height: 1;
			text-transform: uppercase;
			margin-bottom: 10px;
		}
	}

	.item-type {
		font-weight: 500;
	}

	.hero-info-box {
		margin-bottom: 50px;
		min-height: 256px;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		position: relative;
		cursor: pointer;

		.splide__pagination {
			position: absolute;
			display: block;
			left: unset;
			right: 0;
			display: flex;
			flex-direction: column;

			&.placed {
				opacity: 1;
			}

			@include br.respond-to(br.$tablet-small) {
				flex-direction: row;
				margin-top: 30px;
				align-items: flex-start;
				justify-content: flex-start;
				padding: 0;
				position: relative;
			}

			&__page {
				&.is-active {
					background: var(--red);
				}
			}
		}

		@include br.respond-to(br.$tablet-medium) {
			margin-bottom: 30px;
		}
		@include br.respond-to(br.$mobile-xlarge) {
			min-height: unset;
		}

		.volume {
			background: rgba(0, 0, 0, 0.34);
			margin-left: 20px;
			width: 40px;
			height: 40px;

			&.muted {
				position: relative;
				opacity: 0.5;
				&::after {
					content: "";
					position: absolute;
					display: flex;
					left: 5px;
					right: 5px;
					height: 3px;
					background: var(--white);
					transform: rotate(45deg);
				}
				&:hover {
					opacity: 1;
				}
			}
			&:hover {
				cursor: pointer;
			}

			svg {
				width: 20px;
				height: 20px;
			}
		}
	}
	.splide__pagination {
		display: none;
		opacity: 0;
	}
</style>
